import { Zap } from "lucide-react";
import { Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

/* Logo + wordmark → /app when signed in, / otherwise. `to` forces a target (public pages). */
export const BrandLink = ({ to, size = 20, mark = true, testid = "brand-link" }) => {
  const auth = useAuth();
  const href = to || (auth?.user ? "/app" : "/");
  return (
    <Link to={href} className="brand-link" aria-label="DropIt home" data-testid={testid}>
      {mark && <span className="brand-mark"><Zap size={size} strokeWidth={2.75} /></span>}
      <h1 className="brand-title notranslate" translate="no" data-testid="brand-title">DropIt <span className="text-primary">⚡</span></h1>
    </Link>
  );
};
